import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { Box, ThemeProvider } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStore } from '@mcn-platform/models';
import { portalTheme } from '@mcn-platform/converse-lib';
// import LoadGuard from 'components/adminLayout/LoadGuard';
// import GlobalStyles from 'components/GlobalStyles';
import Class from './Class';
import AppBar from '../nav/AppBar';
import CopyrightBar from '../nav/CopyrightBarWidget';
const ClassPage = () => {
    const { status } = useStore();
    const { keyOrID } = useParams();
    if (status !== 'ready') {
        return null;
    }
    return (_jsx(ThemeProvider, { theme: portalTheme, children: _jsxs(Box, { children: [_jsx(AppBar, {}), _jsx(Class, { courseID: keyOrID, settings: {
                        outlineCollapsible: false,
                        showUpNext: true,
                        showNotes: true,
                        showCourseDesc: true,
                        showCourseMaterials: true,
                        showProgressBar: true,
                        showTranscriptTab: true,
                    } }), _jsx(CopyrightBar, {})] }) }));
};
export default observer(ClassPage);
//# sourceMappingURL=ClassPage.js.map